import {
  TableCell,
  TableRow,
} from '@mui/material';
import moment from 'moment';
import { SummaryType } from '@src/lib/types/purchases';
import numeral from 'numeral';

const TableRowItem = (props: SummaryType) => {

  return (
    <TableRow hover tabIndex={-1} role="checkbox" >
      <TableCell align="center">{moment.parseZone(props.purchasedAt).format("MM-DD-YYYY hh:mm A")}</TableCell>
      <TableCell align="center">{props.user.id}</TableCell>
      <TableCell align="center">{props.user.displayName}</TableCell>
      <TableCell align="center">{props.fundType}</TableCell>
      <TableCell align="center">{props.purchaseItem}</TableCell>
      <TableCell align="center">{numeral(props.amount).format("0,000")}</TableCell>
      <TableCell align="center">{props.status}</TableCell>
    </TableRow>
  );
}

export default TableRowItem;
